import React from 'react';

import TypeaheadMultiSuggestion from './Typeahead/TypeaheadSuggestion';

export default function renderMultiSuggestion(suggestion, { inputValue }) {
    return (
        <TypeaheadMultiSuggestion
            value={suggestion.label}
            query={inputValue}
        />
    );
}
